/**
 * @generated SignedSource<<e9b3c155cc8fc90baaa076955d5e8fa8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksSectionMenuArticleSearchConnection$data = {
  readonly aggregations: {
    readonly section: {
      readonly buckets: ReadonlyArray<{
        readonly doc_count: number;
        readonly key: string;
      }>;
    };
  } | null | undefined;
  readonly " $fragmentType": "hooksSectionMenuArticleSearchConnection";
};
export type hooksSectionMenuArticleSearchConnection$key = {
  readonly " $data"?: hooksSectionMenuArticleSearchConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksSectionMenuArticleSearchConnection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksSectionMenuArticleSearchConnection"
};

(node as any).hash = "27c8119969095fc7a56552a8c21bd1b2";

export default node;
